import { AxiosResponse } from 'axios';

interface QueueItem {
    request: () => Promise<AxiosResponse>;
    resolve: (value: any) => void;
    reject: (reason?: any) => void;
}

class AxiosQueue {
    private queue: QueueItem[] = [];
    private isProcessing = false;

    /**
     * POST 또는 PUT 요청을 큐에 추가
     * @param request 실행할 요청 함수
     * @returns Promise
     */
    async enqueue<T>(request: () => Promise<AxiosResponse<T>>): Promise<T> {
        return new Promise((resolve, reject) => {
            this.queue.push({
                request,
                resolve,
                reject,
            });

            // 큐 처리 시작
            this.processQueue();
        });
    }

    /**
     * 큐에 있는 요청을 순차적으로 처리
     */
    private async processQueue(): Promise<void> {
        // 이미 처리 중이거나 큐가 비어있으면 종료
        if (this.isProcessing || this.queue.length === 0) {
            return;
        }

        this.isProcessing = true;
        const item = this.queue.shift() as QueueItem;

        try {
            const response = await item.request();
            item.resolve(response.data);
        } catch (error) {
            item.reject(error);
        } finally {
            this.isProcessing = false;
            // 다음 요청 처리
            this.processQueue();
        }
    }

    /**
     * 큐를 비웁니다
     */
    clearQueue(): void {
        this.queue = [];
    }
}

// 싱글톤 인스턴스 생성
export const axiosQueue = new AxiosQueue();

// 사용 예시:
/*
try {
  const response = await axiosQueue.enqueue(() => 
    axios.post('/api/data', { 
      key: 'value' 
    })
  )
  console.log('성공:', response)
} catch (error) {
  console.error('실패:', error)
}
*/
